import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { CartDrawer } from "@/components/CartDrawer";
import { SubscribePopup } from "@/components/SubscribePopup";
import Home from "@/pages/Home";
import ProductDetail from "@/pages/ProductDetail";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import Experience from "@/pages/Experience";
import Login from "@/pages/Login";
import Account from "@/pages/Account";
import AuthCallback from "@/pages/AuthCallback";

// Detect Emergent Google Auth callback (session_id in URL fragment)
// so we process it BEFORE any other route runs (prevents race conditions).
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/product/:slug" element={<ProductDetail />} />
      <Route path="/checkout/success" element={<CheckoutSuccess />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/experience" element={<Experience />} />
      <Route path="/login" element={<Login />} />
      <Route path="/account" element={<Account />} />
    </Routes>
  );
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App grain min-h-screen bg-cream">
        <CartProvider>
          <AuthProvider>
            <BrowserRouter>
              <AppRouter />
              <CartDrawer />
              <SubscribePopup />
            </BrowserRouter>
          </AuthProvider>
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#FFFCF8",
                color: "#121A16",
                border: "1px solid #EBE5D9",
                fontFamily: "Cabinet Grotesk, sans-serif",
              },
            }}
          />
        </CartProvider>
      </div>
    </ReactLenis>
  );
}

export default App;
